/* eslint-disable @typescript-eslint/no-explicit-any*/
import { SetPayloadPaymentAccountIdType } from '@portal/actions/paymentAccount';
import { SET_PAYMENT_ACCOUNT_ID } from '~/actions/actionTypes';

const initialState: reducers.PaymentAccountReducer = {
  selectedPaymentAccount: null,
};

const paymentAccountReducer = (
  state = initialState,
  action: SetPayloadPaymentAccountIdType
): reducers.PaymentAccountReducer => {
  switch (action.type) {
    case SET_PAYMENT_ACCOUNT_ID:
      state = {
        ...state,
        selectedPaymentAccount: action.payload,
      };
      break;

    default:
      return state;
  }

  return state;
};

export default paymentAccountReducer;
